import React from "react";
import { Direction, Environment, PageMetadataContext } from "./PageMetadataContext";
import { DirectionProvider } from "@radix-ui/react-direction";
export const PageMetadataProvider = ({ locale = "en-us", dir = Direction.LTR, environment = Environment.live, children, }) => {
    return (React.createElement(PageMetadataContext.Provider, { value: { locale, dir, environment } },
        React.createElement(DirectionProvider, { dir: dir }, children)));
};
//# sourceMappingURL=PageMetadataProvider.js.map